// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"528":"da5020fe","868":"2cf78581","961":"20320eae"}[chunkId] + ".css";
};